<template>
  <div>
    <l-button
      class="inline-flex gap-2 items-center border-0 rounded p-1 leading-none hover:bg-gray-400/10 md:px-2"
      @click="openModal"
    >
      <icon set="regular" name="help" class="text-gray-400 text-lg"/>
      <span class="text-base hidden mt-px md:inline-block">Help</span>
    </l-button>

    <modal
      :show="showModal"
      scrollable
      @close="closeModal"
    >
      <template #title>
        Glossary of terms
      </template>

      <template #body>
        <l-input v-model="query" placeholder="Search terms" class="mb-3"/>
        <ul class="list-none pl-0 divide-y divide-gray-100 mb-3 md:h-[600px] overflow-auto">
          <li v-for="term of terms" :key="term.id">
            <details class="group/item relative" :open="terms.length < 5">
              <summary class="py-3 w-full flex items-center gap-3 justify-between list-none cursor-pointer">
                {{ term.title }}
                <i class="text-gray-400 text-sm group-hover/item:text-gray-500 transition-all fa-solid fa-chevron-down group-open/item:rotate-180"/>
              </summary>
              <!-- eslint-disable vue/no-v-html -->
              <div class="space-y-2 prose dark:prose-invert pb-3" v-html="term.body"/>
            </details>
          </li>
        </ul>
        <l-button class="font-medium" :href="route('glossary')">
          View full glossary
        </l-button>
      </template>

      <template #footer>
        <l-button variant="light" @click="closeModal">
          Close
        </l-button>
      </template>
    </modal>
  </div>
</template>

<script setup>
import Icon from "@/components/Icon.vue"
import LButton from "@/components/buttons/LButton.vue"
import LInput from "@/components/inputs/LInput.vue"
import Modal from "@/components/modals/Modal.vue"
import route from "ziggy-js"
import { api } from "@/api"
import { computed, onMounted, ref } from "vue"

const props = defineProps({
  tags: { type: String, required: true },
})

const showModal = ref(false)
const query = ref()
const allTerms = ref([])
const terms = computed(() => {
  if (query.value) {
    return allTerms.value.filter((term) => {
      return term.title.toLowerCase().includes(query.value.toLowerCase())
    })
  }

  return allTerms.value
})

const closeModal = () => {
  showModal.value = false
}

const openModal = () => {
  showModal.value = true
}

onMounted(() => {
  api.termList({ tags: props.tags }).then((r) => {
    allTerms.value = r.data.map((term) => {
      return term
    })
  })
})
</script>
